const langStore = {
  state : {
    lang : 'ko'
  },
  getters: {
    getLang(state) {
      return state.lang
    }
  },
  mutations : {
    setLang(state, param) {
      state.lang = param
    }
  }
}
export default langStore